import * as React from 'react'
import * as styles from './ReviewsRating.module.scss'
import * as cn from 'classnames'
import { Icon, IconType } from '@dvui'

const sanitiseNumber = (number: number) => {
    if (number > 5) {
        return 5
    }
    if (number < 0.5) {
        return 0.5
    }
    return Math.round(number * 2) / 2
}

export const ReviewsRating = ({ rating, className }: { rating: number, className?: string }) => {
    const value = sanitiseNumber(rating)
    const classes = [styles.one, styles.two, styles.three, styles.four]
    const hasHalfStar = Boolean((value * 2) % 2)
    const baseNumber = classes[Math.ceil(value) - 1]
    return (
        <Icon use={IconType.AMAZON_RATING}
            className={cn(styles.rating, className, baseNumber, {
                [styles.hasHalfStar]: hasHalfStar
            }
            )}></Icon>
    )
}